/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from "axios";
import { AuthService } from "../auth/AuthService";
import { ApiBack } from "../axios-config";

export interface IKPI {
  alt_calamiento: number | null;
  borda_livre: number | null;
  for_postsismo: number | null;
  fos_estatico: number | null;
  fos_pseudoestatico: number | null;
  id_barragem: string;
  id_empresa: string;
  infiltracao: number | null;
  longitude: number | null;
  uuid: string;
  vertimiento: number | null;
  vol_minimo: number | null;
}

interface GetKmlData {
  uuid: string[];
}


export interface IInstrumento {
  desabilitado: boolean;
  diametro_tubo: number | null;
  elevacao: number | null;
  elevacao_boca: number | null;
  elevacao_fundo: number | null;
  elevacao_terreno: number | null;
  formula_leitura: string | null;
  freq_monit: number | null;
  freq_monit_medida: string | null;
  id_barragem?: string;
  id_empresa?: string;
  inclinacao: number | null;
  insert_date?: string | null;
  latitude?: number | null;
  limite_faixa_amarela: number | null;
  limite_faixa_amarela_y: number | null;
  limite_faixa_amarela_z: number | null;
  limite_faixa_laranja: number | null;
  limite_faixa_laranja_y: number | null;
  limite_faixa_laranja_z: number | null;
  limite_faixa_verde: number | null;
  limite_faixa_verde_y: number | null;
  limite_faixa_verde_z: number | null;
  limite_faixa_vermelha: number | null;
  limite_faixa_vermelha_y: number | null;
  limite_faixa_vermelha_z: number | null;
  longitude?: number | null;
  motivo_desabilitado: string | null;
  nome: string;
  projecao: string | null;
  responsavel_id: string;
  status: string | null;
  tamanho_icone: number | null;
  tipo: string | null;
  tipo_instrumento: string;
  unidade_medida: string | null;
  update_date?: string | null;
  utm_ew: number | null;
  utm_ns: number | null;
  utm_zone?: number | null;
  uuid?: string;
  cor_icone?: string | null;
  id_icone?: string | null;
  icone?: string;
}

export interface IDam {
  agencia_reguladora: string | null;
  altura_maxima_crista: number | null;
  anm: string | null;
  area_estrutura: number | null;
  berma: string | null;
  composicao_macico: string | null;
  comprimento_crista: number | null;
  cota_crista: number | null;
  curso_dagua_barrado: string | null;
  densidade_rejeito: number | null;
  descricao_acesso: string | null;
  direito_mineracao: string | null;
  elevacao: string | null;
  elevacao_crista: string | null;
  extravasor: string | null;
  fim_operacao: string | null;
  // foto_barragem: string | null;
  funcionarios: string | null;
  fundacao: string | null;
  geracao_rejeito: string | null;
  historico_construtivo: string | null;
  id_empreendimento: string;
  id_empresa: string;
  impermeablizacao: string | null;
  inclinacao_talude_jusante: number | null;
  inclinacao_talude_montante: number | null;
  inicio_operacao: string | null;
  insert_date: string | null;
  inspection_sheet_responsible: string | null;
  latitude: string;
  legenda_faixa_amarela: string | null;
  legenda_faixa_laranja: string | null;
  legenda_faixa_verde: string | null;
  legenda_faixa_vermelha: string | null;
  longitude: string;
  metodo_construtivo: string | null;
  mineral: string | null;
  mineral_presente_rejeito: string | null;
  nome: string;
  processo_beneficiamento: string | null;
  producao_anual: string | null;
  produtos_quimicos: string | null;
  projecao: string | null;
  proposito: string | null;
  qtd_alteamentos_executados: string | null;
  qtd_alteamentos_previstos: string | null;
  rejeito_cianeto: string | null;
  sistema_dranagem: string | null;
  status: boolean;
  status_operacional: string | null;
  teor_mineral_rejeito: string | null;
  teor_outros_mineral_rejeito: string | null;
  teor_solidos_polpa: string | null;
  timezone: string | null;
  total_area: string | null;
  update_date: string | null;
  user_update: string | null;
  utm_ew: number | undefined;
  utm_ns: number | undefined;
  utm_zone: number | undefined;
  utm_zone_location: string | null;
  uuid?: string;
  vazao_residual_curso_dagua: string | null;
  volume_estrutura: string | null;
  volume_macico: string | null;
  kpis?: IKPI[];
  instrumentos?: IInstrumento[];
  image?: string | File;

  empreendimento?: null;
  empresa?: null;
  kpi?: null;
}

export interface IDamsList {
  uuid: string;
  nome: string;
  update_date: string;
  latitude: string;
  longitude: string;
  status: boolean;
  imagem?: string;
  npgb?: 'Alerta' | 'Emergência' | 'Normal';
  plano_acao?: string;
}

const getById = async (uuid: string): Promise<IDam | Error> => {
  await AuthService.verify();

  const token = await AuthService.getAccessToken();

  try {
    const { data } = await ApiBack.get("./dam", {
      params: { uuid: uuid },
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
      },
    });
    if (data) {
      return data;
    }
    return new Error("Erro ao buscar registros.");
  } catch (error) {
    return new Error(
      (error as { message: string }).message ||
        "Erro na requisição de detalhes de Pessoas."
    );
  }
};

const get = async (
  uuid: string | null | undefined
): Promise<IDamsList[] | Error> => {
  await AuthService.verify();

  try {
    const token = await AuthService.getAccessToken();

    const response = await ApiBack.get(`./home-dam?uuid=${uuid}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
      },
    });

    if (response.data) {
      return response.data;
    }

    return new Error("Erro ao listar registros.");
  } catch (error) {
    return new Error(
      (error as { message: string }).message ||
        "Erro na requisição de listagem."
    );
  }
};

const getUnit = async (uuid: string): Promise<IDamsList[] | Error> => {
  await AuthService.verify();

  try {
    const token = await AuthService.getAccessToken();

    const response = await ApiBack.get(`./home-dam?empreendimento=${uuid}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
      },
    });

    if (response.data) {
      return response.data;
    }

    return new Error("Erro ao listar registros.");
  } catch (error) {
    return new Error(
      (error as { message: string }).message ||
        "Erro na requisição de listagem."
    );
  }
};

const getKml = async (uuid: string, data: any): Promise<void> => {
  await AuthService.verify();
  const token = await AuthService.getAccessToken();

  try {
    const response = await ApiBack.post<Blob>(
      `./dam-download-kml?uuid=${uuid}`,
      data,
      {
        responseType: "blob",
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "kml.kml";
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } else {
      throw new Error("Erro ao buscar registros.");
    }
  } catch (error) {
    throw new Error(
      (error as { message: string }).message ||
        "Erro na requisição de detalhes de Pessoas."
    );
  }
};

const getKpi = async (
  uuid?: string,
  empresa?: string,
  barragem?: string
): Promise<any> => {
  await AuthService.verify();

  const token = await AuthService.getAccessToken();

  try {
    const params: Record<string, any> = {};

    if (uuid !== undefined) {
      params["uuid"] = uuid;
    } else if (empresa !== undefined) {
      params["empresa"] = empresa;
    } else if (barragem !== undefined) {
      params["barragem"] = barragem;
    } else {
      return new Error("Erro: faltam parametros.");
    }

    const { data } = await ApiBack.get("./kpi", {
      params: params,
      headers: {
        Authorization: `${token}`,
      },
    });

    if (data) {
      return data;
    }

    return new Error("Erro ao buscar registros.");
  } catch (error) {
    return (
      new Error((error as { message: string }).message) ||
      "Erro na requisição de detalhes de Pessoas."
    );
  }
};

const create = async (uuid: string, data: IDam): Promise<any | Error> => {
  try {
    await AuthService.verify();

    const token = await AuthService.getAccessToken();

    const response = await ApiBack.post(`/create-dam?uuid=${uuid}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
      },
    });

    if (response.data) {
      return response.data;
    }

    return new Error("Erro ao criar nova empresa");
  } catch (error: any) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.error &&
      error.response.data.message
    ) {
      return new Error(error.response.data.message);
    } else {
      return new Error(
        (error as { message: string }).message || "Erro ao criar empresa"
      );
    }
  }
};

const delet = async (uuid: string): Promise<any | Error> => {
  await AuthService.verify();

  try {
    const token = await AuthService.getAccessToken();

    const response = await ApiBack.delete("./dam", {
      headers: {
        Authorization: `${token}`,
      },
      params: {
        uuid: uuid,
      },
    });

    if (response.data) {
      return response.data;
    }

    return new Error("Falha ao deletar empresa");
  } catch (error) {
    Error((error as { message: string }).message || "Erro ao deletar empresa");
  }
};

const upgrade = async (uuid: string, data: IDam): Promise<any | Error> => {
  await AuthService.verify();

  try {
    const token = await AuthService.getAccessToken();

    const response = await ApiBack.put(`./dam?uuid=${uuid}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
      },
    });

    if (response.data) {
      return response.data;
    }

    return new Error("Falha ao atualizar empresa");
  } catch (error) {
    return new Error(
      (error as { menssage: string }).menssage || "Error ao atualizar empresa"
    );
  }
};

const getListDam = async (
  idOrganization: string
): Promise<IDamsList[] | Error> => {
  await AuthService.verify();

  try {
    const token = await AuthService.getAccessToken();

    const response = await ApiBack.get(
      `./dams?empreendimento=${idOrganization}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    if (response.data) {
      return response.data;
    }

    return new Error("Falha ao buscar dados");
  } catch (error) {
    return new Error(
      (error as { menssage: string }).menssage || "Falha ao buscar dados"
    );
  }
};

const getKmlBlob = async (uuid: string, data?: GetKmlData): Promise<AxiosResponse<Blob>> => {
  await AuthService.verify();
  const token = await AuthService.getAccessToken();

  try {
      const response = await ApiBack.post<Blob>(
          `./dam-download-kml?uuid=${uuid}`,
          data,
          {
              responseType: "blob",
              headers: {
                  Authorization: `${token}`,
              },
          }
      );
      return response;

  } catch (error) {
      throw new Error(
          (error as { message: string }).message ||
          "Erro na requisição para obter o Blob do KML."
      );
  }
};

const getForecast = async (
  uuid: string | null | undefined
): Promise<any | Error> => {
  await AuthService.verify();

  try {
    const token = await AuthService.getAccessToken();

    const response = await ApiBack.get(`./previsao?uuid=${uuid}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
      },
    });

    if (response.data) {
      return response.data;
    }

    return new Error("Erro ao listar registros.");
  } catch (error) {
    return new Error(
      (error as { message: string }).message ||
        "Erro na requisição de listagem."
    );
  }
};

export const DamsServices = {
  getById,
  get,
  getKml,
  getKpi,
  create,
  delet,
  upgrade,
  getUnit,
  getListDam,
  getKmlBlob,
	getForecast
};
